import { IWorktimeSchema } from 'shared/repositories/coworking/entities/worktime/WorktimeSchema';

export const getCoworkingAccessInfo = (workTime: IWorktimeSchema | undefined) => {
  if (!workTime) {
    return '';
  }

  const { isAllWeek, isRoundTheClock, timeFrom, timeTo } = workTime;

  const allWeekLabel = isAllWeek ? 'без выходных' : 'пн — пт';
  const worktimeLabel = isRoundTheClock ? 'круглосуточно' : `с ${timeFrom} до ${timeTo}`;

  return `Работает ${worktimeLabel}, ${allWeekLabel}`;
};
